// extracted by mini-css-extract-plugin
export default {"presetActionList":"PresetsMenu-module__presetActionList__rRDei8Y"};